module.exports = __webpack_public_path__ + "img/StChristopher_TH.ca73abbb.png";